import { dateTimeFormat } from '@nike/i18n-core';

/**
 * localizes and formats given min and max iso date strings
 *
 * @private
 * @param {object} params - named parameters
 * @param {string} params.minDate - minimum date as iso string
 * @param {string} params.maxDate - maximum date as iso string
 * @param {string} params.timeZone - timezone of latest arrival date
 * @param {string} params.language - language sensitive date and time formatting
 * @returns {{ formattedMinDate: string, formattedMaxDate: string }} - localized and formatted dates
 */
export default (function (_ref) {
  var minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    language = _ref.language,
    timeZone = _ref.timeZone;
  var dateProps = {
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    timeZone: timeZone
  };
  var finalMinDate = minDate && new Date(minDate);
  var finalMaxDate = maxDate && new Date(maxDate);
  return {
    formattedMinDate: minDate && dateTimeFormat(language, finalMinDate, dateProps),
    formattedMaxDate: maxDate && dateTimeFormat(language, finalMaxDate, dateProps)
  };
});